export { default } from './AnimatedCard';
